import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useProjects } from "../../../projects/projectContext";
import ProjectNeeded from "../../../projects/ProjectNeeded";
import { useNewThread } from "../prepare";
import NewThreadBlocked from "./NewThreadBlocked";

/**
 * `/threads` with no Thread open (F108, built provisionally: Johannes, 29 Oct, "The sidebar IS
 * the Inbox", and "just do what t3 code does in the absence of better direction for threads").
 * As T3 Code opens a new-thread draft, it becomes the Thread view of a new Thread in
 * preparation, through the entry New Thread uses (F110); where nothing can start, it says why
 * (F107). What waits for the person is the sidebar's inbox, not a page.
 */
export default function ThreadsHome() {
  const { t } = useTranslation();
  const projectId = useProjects().selectedProjectId;
  const newThread = useNewThread(projectId);
  const { status, decision, startInPlace } = newThread;
  useEffect(() => {
    if (status === "may") startInPlace();
  }, [status, startInPlace]);

  if (projectId === null) return <div className="mx-auto max-w-3xl p-4"><ProjectNeeded /></div>;
  if (status === "may" || status === "checking") return null;
  return (
    <div className="mx-auto max-w-3xl space-y-2 p-4">
      <h2 className="app-title text-lg font-semibold">{t("sections.threads")}</h2>
      <NewThreadBlocked status={status} decision={decision} />
    </div>
  );
}
